export default __webpack_public_path__ + "static/media/6-saude.7b8cad66.svg";